import { render, staticRenderFns } from "./GenericWarning.vue?vue&type=template&id=64c48968&"
import script from "./GenericWarning.vue?vue&type=script&lang=js&"
export * from "./GenericWarning.vue?vue&type=script&lang=js&"
import style0 from "./GenericWarning.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports